<template>
  <div class="bcc-upload">
    <div
      class="bcc-upload-wrapper"
      @click="openFileDialogOnClick"
      @dragenter.stop.prevent
      @dragover.stop.prevent
      @dragleave.stop.prevent
      @drop.prevent.stop="onFileDrop"
    >
      <template v-if="$slots.default">
        <slot></slot>
      </template>
      <template v-else>
        <section class="bcc-upload-template" :style="templateStyle">
          <bcc-icon
            type="ic_contribute"
            :color="iconColor"
            size="48px"
          ></bcc-icon>
          <span class="tip">上传文件</span>
        </section>
      </template>
      <input
        :accept="accept"
        :multiple="multiple"
        ref="bcc-upload-input"
        type="file"
        style="display: none"
        @change="onFileSelected($event.target.files)"
      />
    </div>
    <div class="list" v-if="showUploadList">
      <image-list
        v-if="listType === 'image'"
        :files="list"
        @handleDelete="handleDelete"
      ></image-list>
      <file-list
        v-else-if="listType === 'text'"
        :files="list"
        @handleDelete="handleDelete"
      >
        文件列表</file-list
      >
    </div>
  </div>
</template>

<script>
import ImageList from './image-list/index'
import FileList from './file-list/index'
import { uploadToExtranet } from './upload.js'
const prefixCls = 'bcc-upload'

export default {
  name: 'BccUpload',
  props: {
    accept: {
      type: String,
      default: '.'
    },
    customRequest: {
      type: Function
    },
    draggable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    listType: {
      // text | image
      type: String,
      default: 'text'
    },
    multiple: {
      // 是否支持多选
      type: Boolean,
      default: false
    },
    showUploadList: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number
    },
    width: {
      type: Number
    }

  },
  components: {
    'image-list': ImageList,
    'file-list': FileList
  },
  computed: {
    wrpClasses () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-disabled`]: this.disabled
        }
      ]
    },
    templateStyle () {
      let style = {}
      if (this.width) {
        style['width'] = this.width
      }
      if (this.height) {
        style['height'] = this.height
      }
      return style
    },
    iconColor () {
      if (this.disabled) {
        return '#999999'
      } else {
        return '#00a1d6'
      }
    },
    uploadFile () {
      if (this.customRequest) {
        return this.customRequest
      } else {
        return uploadToExtranet
      }
    }
  },
  data () {
    const fileList = this.fileList
    return {
      list: fileList
    }
  },
  methods: {
    // 文件选择完成
    onFileSelected (files) {
      this.$emit('onChange', files)
      for (let i = 0; i < files.length; i++) {
        const index = this.showPending(files[i])
        this.upload(files[i], index)
      }
    },
    // 打开文件选择器
    openFileDialogOnClick () {
      if (this.disabled) {
        this.$emit('uploadErr', { msg: 'disabled' })
        return
      }
      const input = this.$refs['bcc-upload-input']
      input.value = null
      this.$refs['bcc-upload-input'].click()
      this.$emit('openFileDialogOnClick')
    },
    onFileDrop (e) {
      if (this.draggable) {
        e.stopPropagation()
        e.preventDefault()
        const { files } = e.dataTransfer
        this.$emit('onDrop', files)
        this.onFileSelected(files)
      }
    },
    showPending (file) {
      const newImage = {
        status: 'pending',
        name: file.name
      }
      this.list.push(newImage)
      return this.list.length - 1
    },
    upload (file, i) {
      let newImage = this.createFailedImage()
      newImage.name = file.name
      this.uploadFile(file)
        .then((res) => {
          if (res.url) {
            newImage = { ...newImage, status: 'success', url: res.url }
          }
          this.$emit('uploaded', { i, ...newImage, file, index: i })
          this.$set(this.list, i, newImage)
        })
        .catch((error) => {
          this.$emit('uploadErr', { msg: 'upload', index: i, file, error })
          this.$set(this.list, i, newImage)
        })
    },
    createFailedImage () {
      let newImage = {
        url: '',
        name: '',
        status: 'failed'
      }
      return newImage
    },
    handleDelete ({ index }) {
      this.$emit('onRemove', this.list[index])
      this.list.splice(index, 1)
    }
  }
}
</script>
